const link = "_ibql1mzdau9";
const content = "_ibqc12zhp6v";
const label = "_ibql1chw3sm";
const value = "_ibqvdplkb0";

export { content, label, link, value };
import "./atom.trigger.style.linaria.module.css";
//# sourceMappingURL=atom.trigger.style.js.map
